export const chargeExplain = {
    "connectToBank": "התחברות לחשבון הבנק"
};
